import {RootState} from '../../testutils/configureStore'

export const selectIsHoldOutGroup = (state: RootState) =>
  state.priceWatch.isHoldOutGroup
